module.exports = __webpack_public_path__ + "img/clickfunnels_5.c7145b26.png";